import { mensagemPadrao } from 'src/dados-estaticos'
import * as Yup from 'yup'

export const schema = Yup.object().shape({
  usuario: Yup.string().required(mensagemPadrao),
  senha: Yup.string().required(mensagemPadrao)
})
